import { useContext, useEffect } from 'react';
import SearchContext from '../../../context/search-context';
import APIError from '../../../services/APIError';
import Search from '../../common/Search/Search';
import { findCustomer } from '../../../services/customer/customerService';
import Customer from '../../../models/Customer';

type RepresentativeSearchProps = {
  customer: Customer
}

function RepresentativeSearch(props: RepresentativeSearchProps) {
  const searchCtx = useContext(SearchContext);
  const searchLimit = 100;

  useEffect(() => {
    searchCtx.setSearchResult([]);
  }, []);

  const searchSubmitHandler = async (input: string) => {
    try {
      const result = await findCustomer({ searchText: input });
      if (result.length > searchLimit) {
        searchCtx.setShowNotification(true);
        result.pop();
      } else {
        searchCtx.setShowNotification(false);
      }
      const representatives = result.filter(
        representative => representative.personType === 'PRIVATE' &&
          representative.id !== props.customer.id,
      );
      searchCtx.setSearchResult(representatives);
    } catch (err) {
      if (err instanceof APIError) {
        console.log(`Failed to find representatives: ${err.errorBody}`);
      } else {
        console.log(err);
      }
    }
  };

  return (
    <Search onSubmit={searchSubmitHandler} />
  );
}

export default RepresentativeSearch;
